import { Attribute } from "./AttributesDetails";

export const countObject = (
  value?: string | number | Attribute | Attribute[],
) => {
  if (!value) return 0;

  if (Array.isArray(value)) {
    return value.length;
  }

  return Object.keys(value).length;
};
